import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90325cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Riders Detail")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row height d-flex justify-content-center align-items-center" })
], -1))
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Id", -1))
const _hoisted_8 = { class: "col-sm-3 text-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name", -1))
const _hoisted_10 = { class: "col-sm-3 text-end" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Email", -1))
const _hoisted_13 = { class: "col-sm-3 text-end" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Phone", -1))
const _hoisted_15 = { class: "col-sm-3 text-end" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Device Type", -1))
const _hoisted_18 = { class: "col-sm-3 text-end" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Available", -1))
const _hoisted_20 = { class: "col-sm-3 text-end" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "IS Buzy", -1))
const _hoisted_23 = { class: "col-sm-3 text-end" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Wallet Amount", -1))
const _hoisted_25 = { class: "col-sm-3 text-end" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Riders Earning")
  ])
], -1))
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table table-striped table-sm" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Order No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Delivery date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total distance"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Peak factor"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Distance amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Created_at")
  ])
], -1))
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = { class: "text-start" }
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "text-start" }
const _hoisted_37 = { class: "text-start" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Riders Earning")
  ])
], -1))
const _hoisted_39 = { class: "table table-striped table-sm" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Order No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Item No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Transaction Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Title"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Created At")
  ])
], -1))
const _hoisted_41 = { class: "text-start" }
const _hoisted_42 = { class: "text-start" }
const _hoisted_43 = { class: "text-start" }
const _hoisted_44 = { class: "text-start" }
const _hoisted_45 = { class: "text-start" }
const _hoisted_46 = { class: "text-start" }
const _hoisted_47 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminPagination = _resolveComponent("AdminPagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.rider.id), 1),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString($setup.rider.rider_name), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.rider.rider_email), 1),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.rider.rider_mobile_no), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString($setup.rider.device_type), 1),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString($setup.rider.availability_status), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString($setup.rider.is_buzy), 1),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString($setup.rider.quickup_wallet_amount), 1)
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("table", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riderearnings, (riderearning) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: riderearning.id
                  }, [
                    _createElementVNode("td", _hoisted_30, _toDisplayString(riderearning.id), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(riderearning.order.id), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString($options.dateTime(riderearning.order_delivery_date)), 1),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(riderearning.total_distance) + " " + _toDisplayString(riderearning.order.country.distance_type), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(riderearning.peak_factor), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(riderearning.order.country.currency_short_name) + _toDisplayString(riderearning.distance_amount), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(riderearning.order.country.currency_short_name) + _toDisplayString(riderearning.total_amount), 1),
                    _createElementVNode("td", _hoisted_37, _toDisplayString($options.dateTime(riderearning.created_at)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AdminPagination, {
      "last-page": $setup.lastPage,
      onPageChanged: _cache[0] || (_cache[0] = ($event: any) => ($setup.load($event)))
    }, null, 8, ["last-page"]),
    _hoisted_38,
    _createElementVNode("table", _hoisted_39, [
      _hoisted_40,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riderwallets, (riderwallet) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: riderwallet.id
          }, [
            _createElementVNode("td", _hoisted_41, _toDisplayString(riderwallet.id), 1),
            _createElementVNode("td", _hoisted_42, _toDisplayString(riderwallet.order.id), 1),
            _createElementVNode("td", _hoisted_43, _toDisplayString(riderwallet.orderitem.id), 1),
            _createElementVNode("td", _hoisted_44, _toDisplayString(riderwallet.transaction_type), 1),
            _createElementVNode("td", _hoisted_45, _toDisplayString(riderwallet.country.currency_short_name) + _toDisplayString(riderwallet.amount), 1),
            _createElementVNode("td", _hoisted_46, _toDisplayString(riderwallet.title), 1),
            _createElementVNode("td", _hoisted_47, _toDisplayString($options.dateTime(riderwallet.created_at)), 1)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}